@if (standardrecht$ || pfandrecht$ | async; as recht) {
  <div>
    <cap-content-header>
      <cap-title>
        <span> {{ recht.rechtArt | translate }} {{ recht.rechteId | formatRechteId }} </span>
      </cap-title>
      <cap-title-functionbar>
        <div class="inline-form float-end">
          @if (recht?.rechtArt !== "PFANDRECHT") {
            @if (mapsVerfuegbar) {
              <button class="btn btn-white btn-sm me-2" type="button">
                <cap-maps
                  (mapVerfuegbar)="setShowMap($event)"
                  [mapType]="recht.rechtArt"
                  [model]="recht.versions[0] ? recht.versions[0] : null"
                  [tooltip]="recht.rechtArt | translate"></cap-maps>
              </button>
            }
            @if (!isDokulinkMenuDisabled()) {
              <button class="btn btn-white btn-sm me-2" type="button">
                <cap-dokulink
                  (dokulinkVerfuegbar)="setShowDokulink($event)"
                  [item]="dokuLinkBuilderFactory.create('RECHT').setEntry(recht).build()"
                  [showTitle]="false"></cap-dokulink>
              </button>
            }
          }
          <cap-auszug [item]="recht" [rechtVersionId]="rechtVersionId.id"></cap-auszug>
        </div>
      </cap-title-functionbar>
    </cap-content-header>
    <ul [(activeId)]="rechtArt" #nav="ngbNav" class="nav-tabs" ngbNav>
      <li [ngbNavItem]="'rechtArt'">
        <a ngbNavLink>{{ recht?.rechtArt | translate }}</a>
        <ng-template id="tabRechtArt" ngbNavContent>
          <div>
            <div class="scrollspy-example" data-offset="0" data-spy="scroll" data-target="#list-example">
              @if (recht?.rechtArt !== "PFANDRECHT") {
                <span>
                  <cap-standardrecht-kopfdaten [recht]="recht" [versionId]="rechtVersionId"></cap-standardrecht-kopfdaten>
                </span>
              }
              @if (recht?.rechtArt === "PFANDRECHT") {
                <span>
                  <cap-pfandrecht-kopfdaten [recht]="recht" [versionId]="rechtVersionId"></cap-pfandrecht-kopfdaten>
                </span>
              }
            </div>
          </div>
        </ng-template>
      </li>
      @if (recht?.rechtArt !== "PFANDRECHT") {
        <li [ngbNavItem]="'vertragstexte'">
          <a ngbNavLink>{{ "Vertragstexte" | translate }}</a>
          <ng-template id="tabvertragstexte" ngbNavContent>
            <div class="mt-md-2 mx-0 vertragstext-tab-detail">
              @if (recht?.rechtArt !== "PFANDRECHT") {
                @if (recht.versions[0].mVertragstext?.access == "NONE") {
                  <span>
                    {{ "gemaessGrundbuch" | translate }}
                  </span>
                } @else {
                  <textarea
                    [capHistinfo]="recht.versions[0].histInfo"
                    [ngModel]="recht.versions[0].vertragstext"
                    class="textarea-detail col-md-12 m-0"
                    name="vertragstext"
                    readonly
                    style="height: 100%; resize: none">
                  </textarea>
                }
                <ng-template #vertragstext>
                  <textarea
                    [capHistinfo]="recht.versions[0].histInfo"
                    [ngModel]="recht.versions[0].vertragstext"
                    class="textarea-detail col-md-12 m-0"
                    name="vertragstext"
                    readonly
                    style="height: 100%; resize: none">
                  </textarea>
                </ng-template>
              }
            </div>
          </ng-template>
        </li>
      }
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
    <div id="rubriken">
      <div class="m-0 scrollspy-example" data-offset="0" data-spy="scroll" data-target="#list-example">
        @if (recht?.rechtArt !== "PFANDRECHT") {
          <span>
            @for (rubrik of getRubriken(recht.rechtArt); track rubrik) {
              <cap-recht-rubrik
                [hasRight]="permissionService.hasPermission('ANZEIGE_DETAILS_HAENGIGE_GESCHAEFTE')"
                [item]="rubrik"
                [rechtVersionId]="rechtVersionId"
                [standardrecht]="recht"></cap-recht-rubrik>
            }
          </span>
        }
        @if (recht?.rechtArt === "PFANDRECHT") {
          <span>
            @for (rubrik of getRubriken(recht.rechtArt); track rubrik) {
              <cap-recht-rubrik
                [hasRight]="permissionService.hasPermission('ANZEIGE_DETAILS_HAENGIGE_GESCHAEFTE')"
                [item]="rubrik"
                [pfandrecht]="recht"
                [rechtVersionId]="rechtVersionId">
              </cap-recht-rubrik>
            }
          </span>
        }
      </div>
    </div>
  </div>
} @else {
  @if (stillLoading) {
    <cap-spinner-small [withBreadcrumb]="true"></cap-spinner-small>
  }
}
